<template>
  <div id="app">
      <keep-alive>
        <router-view />
      </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      activeTab: 0
    }
  },
  computed: {
    ...mapGetters(['cartCount']),
    
  },
  watch: {
    
  }
}
</script>

<style lang="less">
#app {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  max-width: 750px;
  margin: 0 auto;
  position: relative;
  background: #f5f7fa;
  
  .main-content {
    padding-top: 46px;
    padding-bottom: 50px;
    min-height: 100vh;
    box-sizing: border-box;
    
    &.has-tabbar {
      padding-bottom: 100px;
    }
  }
}
</style>